/* eslint-env browser */
/* eslint-disable */
const getCityStatus = (status_required) => {
  return status_required
}

export default getCityStatus;